
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IconName } from "@/lib/icons/icons";
import RawIcon from "@/components/UI/RawIcon.vue";
import Icon from "@/components/UI/Icon.vue";
import { IconRotation } from "@/types/icons";
import { configStore } from "@/store/store";

@Component({
  components: { Icon, RawIcon }
})
export default class IconButton extends Vue {
  @Prop()
  icon!: IconName;

  @Prop({
    default: false
  })
  active!: boolean;

  @Prop({
    default: false
  })
  disabled!: boolean;

  @Prop()
  testId!: string;

  @Prop()
  size?: string;

  @Prop()
  rotate?: IconRotation;

  @Prop({ default: false })
  xSmall!: boolean;

  @Prop({ default: false })
  small!: boolean;

  @Prop({ default: "" })
  tooltip!: string;

  showTooltip = false;

  get classList() {
    return {
      "breakdance-toolbar-icon-button": true,
      "breakdance-toolbar-icon-button-active": this.active,
      "breakdance-toolbar-icon-button-small-button": this.small,
      "breakdance-toolbar-icon-button-xs-button": this.xSmall,
      "breakdance-toolbar-icon-button-disabled": this.disabled
    };
  }

  get iconColor() {
    return this.active ? "brand_primary" : "gray1000";
  }

  get listeners() {
    if (!this.disabled) {
      return this.$listeners;
    }
    return false;
  }

  get builderMode() {
    return configStore.builderMode;
  }

  timeout: NodeJS.Timeout | null = null;

  delayShowTooltip() {
    if (!this.tooltip) return;

    this.timeout = setTimeout(() => {
      this.showTooltip = true;
    }, 500);
  }

  closeTooltip() {
    this.showTooltip = false;
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  mounted() {
    const button = this.$refs.button as HTMLElement | undefined;

    if (button && this.tooltip) {
      button.addEventListener("click", this.closeTooltip);
    }
  }

  beforeDestroy() {
    const button = this.$refs.button as HTMLElement | undefined;

    if (button && this.tooltip) {
      button.removeEventListener("click", this.closeTooltip);
    }
  }
}
